// Unified color constants for charts and graphs
// Based on Ant Design color palette

// Base color palette for charts and analyses
export const CHART_COLORS = {
  // Primary colors
  BLUE: '#188ca6',
  BLUE_OPACITY: 'rgba(24, 140, 166, 0.7)',
  LIGHT_BLUE: '#b0dde8',
  LIGHT_BLUE_OPACITY: 'rgba(176, 221, 232, 0.7)',

  GREEN: '#52c41a', // green-6 - for positive changes and success states
  GREEN_OPACITY: 'rgba(82, 196, 26, 0.7)',
  LIGHT_GREEN: '#b7eb8f',
  LIGHT_GREEN_OPACITY: 'rgba(183, 235, 143, 0.7)',

  RED: '#f5222d', // red-5 - for negative changes and error states
  RED_OPACITY: 'rgba(245, 34, 45, 0.7)',
  LIGHT_RED: '#ffa39e',
  LIGHT_RED_OPACITY: 'rgba(255, 163, 158, 0.7)',

  YELLOW: '#fa8c16', // orange-6 - for warning states
  YELLOW_OPACITY: 'rgba(250, 140, 22, 0.7)',
  LIGHT_YELLOW: '#ffd591',
  LIGHT_YELLOW_OPACITY: 'rgba(255, 213, 145, 0.7)',

  // Neutral colors
  GREY: '#c1c1c1',
  LIGHT_GREY: '#eee',
  WHITE: '#fff',
  BLACK_OPACITY: 'rgba(19, 19, 19, 0.7)',

  // Additional semantic colors
  INFO: '#1890ff', // blue-6 - for info states
  PROCESSING: '#13c2c2', // cyan-6 - for processing states
  DISABLED: '#8c8c8c', // gray-6 - for disabled states
  TEXT_PRIMARY: '#262626', // gray-9 - for primary text
  TEXT_SECONDARY: '#8c8c8c', // gray-6 - for secondary text
  BORDER_LIGHT: '#f0f0f0', // gray-3 - for light borders
};

// Adoption dashboard specific color mappings
export const ADOPTION_COLORS = {
  IN_PREPARATION: CHART_COLORS.DISABLED,
  READY: CHART_COLORS.INFO,
  SUBMITTED: CHART_COLORS.YELLOW,
  RECEIVED: CHART_COLORS.PROCESSING,
  LIVE: CHART_COLORS.GREEN,
  SUCCESS: CHART_COLORS.GREEN,
  ERROR: CHART_COLORS.RED,
  WHITE: CHART_COLORS.WHITE,
  TEXT_PRIMARY: CHART_COLORS.TEXT_PRIMARY,
  TEXT_SECONDARY: CHART_COLORS.TEXT_SECONDARY,
  BORDER_LIGHT: CHART_COLORS.BORDER_LIGHT,
};

// Progress bar color mappings (same as adoption for consistency)
export const PROGRESS_COLORS = {
  IN_PREPARATION: CHART_COLORS.DISABLED,
  READY: CHART_COLORS.INFO,
  SUBMITTED: CHART_COLORS.YELLOW,
  RECEIVED: CHART_COLORS.PROCESSING,
  LIVE: CHART_COLORS.GREEN,
};

// Legacy color mappings for backward compatibility
export const LEGACY_COLORS = {
  blue: CHART_COLORS.BLUE,
  blueOpacity: CHART_COLORS.BLUE_OPACITY,
  lightBlue: CHART_COLORS.LIGHT_BLUE,
  lightBlueOpacity: CHART_COLORS.LIGHT_BLUE_OPACITY,
  green: CHART_COLORS.GREEN,
  greenOpacity: CHART_COLORS.GREEN_OPACITY,
  lightGreen: CHART_COLORS.LIGHT_GREEN,
  lightGreenOpacity: CHART_COLORS.LIGHT_GREEN_OPACITY,
  red: CHART_COLORS.RED,
  redOpacity: CHART_COLORS.RED_OPACITY,
  lightRed: CHART_COLORS.LIGHT_RED,
  lightRedOpacity: CHART_COLORS.LIGHT_RED_OPACITY,
  yellow: CHART_COLORS.YELLOW,
  yellowOpacity: CHART_COLORS.YELLOW_OPACITY,
  lightYellow: CHART_COLORS.LIGHT_YELLOW,
  lightYellowOpacity: CHART_COLORS.LIGHT_YELLOW_OPACITY,
  grey: CHART_COLORS.GREY,
  lightGrey: CHART_COLORS.LIGHT_GREY,
  white: CHART_COLORS.WHITE,
  blackOpacity: CHART_COLORS.BLACK_OPACITY,
};

// Analysis interval options
export const INTERVAL_OPTIONS = [
  { id: 1, name: '2 weeks' },
  { id: 2, name: '3 month' },
  { id: 3, name: '1 year' },
  { id: 4, name: 'all time' },
];

// Icon sizing constants for analysis views
export const ICON_SIZES = {
  leftInit: -21,
  leftAdd: 90.3,
  topInit: 0,
  positionIconBottom: 181,
  positionIconMiddle: 167,
  positionIconTop: 153,
  scaleUp: 137,
};
